import React from 'react';
import { motion } from 'framer-motion';
import './LegalPage.css';

const KVKKPage = () => {
  return (
    <div className="legal-page">
      {/* Hero */}
      <section className="legal-hero">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            KVKK Aydınlatma Metni
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Bursluluk Sınavında İşlenen Kişisel Verilere İlişkin Aydınlatma Metni
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className="legal-content">
        <div className="container">
          <motion.div
            className="legal-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="intro">
              <strong>Sayın Veli,</strong>
            </p>
            <p>
              İşbu aydınlatma metni, veri sorumlusu sıfatıyla hareket eden <strong>BMK EĞİTİM KURUMLARI</strong> tarafından, 
              6698 sayılı Kişisel Verilerin Korunması Kanununun ("KVKK") 10. maddesi ile Aydınlatma Yükümlülüğünün 
              Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ çerçevesinde, kişisel verilerinizin 
              işlenme amaçları, hukuki nedenleri, toplanma yöntemlerini, kimlere aktarılabileceğini ve KVKK 
              kapsamındaki haklarınıza ilişkin olarak sizleri bilgilendirmek amacıyla hazırlanmıştır.
            </p>

            <div className="legal-section">
              <h2>Toplanan Kişisel Veriler ve İşleme Amaçları</h2>
              <p>
                BMK EĞİTİM KURUMLARI olarak bursluluk sınavına başvuru ve katılım halinde tarafınıza (veli) ait 
                <strong> ad, soyad, telefon numarası, adres, e-posta</strong> verilerini; çocuğunuza (öğrenci) ait ise 
                <strong> ad, soyad, doğum tarihi, T.C. Kimlik numarası, eğitim bilgileri ve sınav sonucu</strong> tipindeki 
                kişisel veriler aşağıdaki amaçlarla sınırlı olarak işlenmektedir:
              </p>
              <ul>
                <li>Bursluluk sınavı başvurularının alınması ve kayıt işlemlerinin yapılması</li>
                <li>Sınava katılımın sağlanması, kimlik teyidi ve sınav güvenliğinin temini</li>
                <li>Sınav kitapçıklarının ve salonlarının belirlenmesi</li>
                <li>Sınav sonuçlarının hesaplanması, açıklanması ve tarafınıza bildirilmesi</li>
                <li>Öğrenci seviye tespitinin yapılabilmesi ve başarı durumunun değerlendirilmesi</li>
                <li>Faaliyetlerin mevzuata uygun yürütülmesi</li>
              </ul>
              <p className="highlight">
                <strong>Önemli:</strong> Söz konusu veriler, pazarlama, reklam veya kampanya bildirimi amacıyla kullanılmayacaktır.
              </p>
            </div>

            <div className="legal-section">
              <h2>Hukuki Sebepler ve Veri Toplama Yöntemi</h2>
              <p>
                Size ve çocuğunuza ait kişisel veriler, yukarıda bahsedilen amaçlar doğrultusunda 6698 sayılı 
                Kişisel Verileri Koruma Kanunu'nun ("Kanun") madde 5/2-c bendinde yer alan <em>"bir sözleşmenin 
                kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla"</em> hukuki sebebiyle ve madde 5/2-f 
                bendinde belirtilen <em>"veri sorumlusunun meşru menfaati"</em> hukuki sebebine dayalı olarak, 
                web sitemizdeki başvuru formu aracılığıyla otomatik yollarla toplanmaktadır.
              </p>
            </div>

            <div className="legal-section">
              <h2>Verilerin Aktarımı</h2>
              <p>
                Yukarıda sayılan kişisel verileriniz, ilgili amaçların icra edilebilmesi adına BMK EĞİTİM KURUMLARI'nın 
                yetkili birimleri tarafından işlenecektir. İşbu veriler yalnızca kurumumuz bünyesinde tutulmakta olup, 
                <strong> yasal zorunluluklar (MEB veya yetkili kamu kurumları talepleri) haricinde üçüncü kişilere aktarılmamaktadır.</strong>
              </p>
            </div>

            <div className="legal-section">
              <h2>KVKK Kapsamındaki Haklarınız</h2>
              <p>Dilediğiniz zaman BMK EĞİTİM KURUMLARI'na başvurarak:</p>
              <ul>
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>Kanun'un 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
              </ul>
              <p>haklarınızı kullanmayı talep edebilirsiniz.</p>
            </div>

            <div className="legal-section">
              <h2>Başvuru Yöntemi</h2>
              <p>
                Haklarınıza ve Kanunun uygulanmasına ilişkin taleplerinizi aşağıdaki yollarla iletebilirsiniz:
              </p>
              <ul className="contact-list">
                <li><strong>Yazılı Başvuru:</strong> Huzurevleri, 77234. Sk. No:2, 01170 Çukurova/Adana adresine noter kanalıyla veya şahsi başvurunuzla</li>
                <li><strong>E-posta:</strong> bmkegitim@gmail.com</li>
              </ul>
              <p>
                BMK EĞİTİM KURUMLARI, bu kapsamdaki taleplere yazılı olarak cevap verilecekse, on sayfaya kadar 
                ücret almadan; on sayfanın üzerindeki her sayfa için 1 Türk Lirası işlem ücreti alarak yanıtlandıracaktır.
              </p>
            </div>

            <div className="legal-footer">
              <p><strong>BMK EĞİTİM KURUMLARI</strong></p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default KVKKPage;
